import { PromoTypes } from '../constants/promo.types';
import { ActionModel } from '../../typeDef/redux.model';

export const setPromoCode = (code: any): ActionModel => {
  return {
    type: PromoTypes.SET_PROMO_CODE,
    payload: code
  }
}